import { render, staticRenderFns } from "./SupportTicketDetail.vue?vue&type=template&id=deb340f0"
import script from "./SupportTicketDetail.vue?vue&type=script&lang=js"
export * from "./SupportTicketDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports